import { ExportParams } from "../types/export-dropdown.types";

import { tr } from '@/i18n';
export const handleGenericExport = async <TFilters extends Record<string, any>>(
  params: ExportParams<TFilters>
): Promise<void> => {
  const {
    filters,
    format,
    exportApiCall,
    fileNamePrefix,
    setIsExporting,
    showNotification,
    entityName,
  } = params;

  setIsExporting(true);
  try {
    const fileBlob = await exportApiCall(format, filters);

    const url = window.URL.createObjectURL(fileBlob);

    if (format === 'pdf') {
      // Open PDFs in a new tab — Chrome's built-in PDF viewer works with blob: URLs
      // but refuses to load file:// PDFs from the sandbox (security restriction).
      const newTab = window.open(url, '_blank');
      if (!newTab) {
        // Popup blocked — fall back to download
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${fileNamePrefix}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode?.removeChild(link);
      }
      // Revoke after a short delay to let the new tab finish loading
      setTimeout(() => window.URL.revokeObjectURL(url), 30_000);
    } else {
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${fileNamePrefix}.${format}`);
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
      window.URL.revokeObjectURL(url);
    }

    showNotification(tr("ui.x_exported_as_x_successfully", "{v0} exported as {v1} successfully!", { v0: entityName, v1: format.toUpperCase() }), 'success');
  } catch (err: any) {
    console.error(`Error exporting ${entityName.toLowerCase()} as ${format.toUpperCase()}:`, err);
    let message = tr("ui.failed_to_export_x_as_x", "Failed to export {v0} as {v1}.", { v0: entityName.toLowerCase(), v1: format.toUpperCase() });
    if (err.response && err.response.data && typeof err.response.data.detail === 'string') {
        message = err.response.data.detail;
    } else if (err.message && typeof err.message === 'string') {
        message = err.message;
    }
    showNotification(message, 'error');
  } finally {
    setIsExporting(false);
  }
};